<template>
    <section class="data-panel">
        <div class="content">
            <slot></slot>
        </div>
        <div class="action-bar">
            <small><span class="hidden-print">Download all</span> <strong>{{count}}</strong> records <span class="hidden-print">in:</span></small>
            <button class="btn btn-sm hidden-print" @click="download('csv')" :class="btnType"><i class="fa fa-download"></i> CSV</button>
            <button class="btn btn-sm hidden-print" @click="download('xlsx')" :class="btnType"><i class="fa fa-download"></i> Excel</button>

            <div class="pull-right hidden-xs hidden-print">
                <small><a class="link" v-for="link in links" :href="link.href">{{link.name}}</a></small>
            </div>
        </div>
        <div class="unlock-button-wrapper">
            <button @click="unlock" class="unlock btn btn-upgrade btn-large"><i class="fa fa-unlock"></i> Unlock real report for #{{hashtag}}</button>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'data-panel',
        props: {
            count: {
                default: 0,
                type: Number
            },
            type: {
                default: '',
                type: String
            },
            links: {
                default: [],
                type: Array
            },
            'btn-type': {
                default: 'btn-default',
                type: String
            },
            'hashtag': {
                default: '',
                type: String
            },
            'uuid': {
                default: '',
                type: String
            },
            'loggedIn': {
                default: false,
                type: Boolean
            }
        },
        methods: {
            download (format) {
                let loc = null
                const uuid = this.uuid // window.location
                if (format === 'xlsx') {
                    loc = '/api/v2/report/export?format=xlsx&type=' + this.type + '&uuid=' + uuid
                } else {
                    loc = '/api/v2/report/export?format=csv&type=' + this.type + '&uuid=' + uuid
                }
                if (loc && this.type) {
                    window.location = loc
                }
            },
            unlock () {
                this.$parent.$emit('unlock')
            }
        }
    }
</script>

<style scoped lang="scss">
    .data-panel {
        border: 1px solid #ddd;
        border-radius: 8px;
        box-shadow: 0 4px 4px rgba(0, 0, 0, .05);
        margin: 20px 5px;
        flex-grow: 1;
        flex-basis: 40%;
        min-width: 300px;
        position: relative;
        padding-bottom: 50px;
        page-break-inside: avoid;
        overflow: hidden;

        &.loading-animation {
            -webkit-filter: grayscale(100%);
            filter: grayscale(100%);
            pointer-events: none;
            animation-name: blink;
            animation-duration: 2s;
            animation-timing-function: ease-out;
            animation-iteration-count: infinite;

            h3, th, td, small, button {
                background-color: #e0e0e0;
                color: #e0e0e0;
                border-color: #e0e0e0;
            }
        }

        &.locked {

            .content, .action-bar {
                -webkit-filter: grayscale(100%);
                filter: grayscale(100%);
                opacity: 0.4;
                pointer-events: none;
            } 

            .unlock-button-wrapper {
                display:block !important;
            }
        }
        .content {
            padding: 8px 16px;

            h2, h3 {
                text-align: center;
            }

            table.table {
                font-size: 14px;
                >tbody>tr>td {
                    padding: 6px;
                }
                &.fading {
                    position:relative;

                    &:after {
                        content: ' ';
                        height: 80px;
                        width: 100%;
                        /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+100 */
                        background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); /* FF3.6-15 */
                        background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* Chrome10-25,Safari5.1-6 */
                        background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
                        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */
                        position: absolute;
                        bottom: 0px;
                    }
                }
            }
        }

        .action-bar {
            background: #F4F4F4;
            padding: 8px 16px;
            line-height: 32px;
            border-bottom-left-radius: inherit;
            border-bottom-right-radius: inherit;
            position:absolute;
            bottom:0;
            width:100%;

            .link {
                padding: 2px 4px;
            }
        }

        .unlock-button-wrapper {
            display:none;
            width:100%;
            position: absolute;
            top: 45%;
            left: 0%;
            text-align: center;
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/DataPanel.vue